module.exports = __webpack_public_path__ + "img/n1.15276a6a.png";